export default __webpack_public_path__ + "e1deaf36a21ab39e9eeab5a61b4b7426.png";